import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { RadioButton } from "components";

import styles from "./businessInfo.module.scss";

const IsItNewMerchant = () => (
	<Row>
		<Col>
			<div className={`${styles.addressTitle} mb-4`}>
				Is it a new merchant?
			</div>
			<div className={styles.inlineItems}>
				<Field
					component={RadioButton}
					value="new"
					className={styles.item}
					name="merchantType"
					label="New Merchant"
					type="radio"
					id="merchantType_merchant"
				/>
				<Field
					component={RadioButton}
					value="additional_location"
					className={styles.item}
					name="merchantType"
					label="Additional Location"
					type="radio"
					id="merchantType_location"
				/>
			</div>
		</Col>
	</Row>
);

export default memo(IsItNewMerchant);
